import React, { useCallback, useId } from 'react'
import PropTypes from 'prop-types'
import { useField } from 'formik'
import { FormGroup, Input } from '@theneatcompany/nui'
import { useIntl } from 'react-intl'

import FieldError from './FieldError'

const InputField = ({
  labelProps = {},
  errorProps = {},
  placeholder = '',
  hidePlaceholder = false,
  name,
  onChange,
  ...rest
}) => {
  const id = useId()
  const { formatMessage } = useIntl()
  const { label = '', hideLabel } = labelProps

  const [{ value = '', ...field }, { error, touched, initialValue }, { setValue, setTouched }] = useField(name)

  const handleInputChange = useCallback(({ target: { value: val } }) => {
    if (onChange) onChange(val)
    if (val === '' && initialValue === undefined) {
      setValue(undefined)
      return
    }
    setValue(val)
  }, [initialValue])

  const hasErrors = !!(error && touched)

  return (
    <FormGroup intent={hasErrors ? 'danger' : 'default'}>
      {!hideLabel && <FormGroup.Label htmlFor={id} label={label} {...labelProps} />}
      <Input
        {...rest}
        id={id}
        placeholder={hidePlaceholder ? ' ' : placeholder || formatMessage({ id: 'placeholders.default' }, { label })}
        {...field}
        onBlur={setTouched}
        onChange={handleInputChange}
        value={value}
        leftIcon={hasErrors ? 'error' : null}
      />
      <FieldError message={error} label={label} touched={touched} {...errorProps} />
    </FormGroup>
  )
}

InputField.propTypes = {
  placeholder: PropTypes.string,
  hidePlaceholder: PropTypes.bool,
  labelProps: PropTypes.shape({
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
    hideLabel: PropTypes.bool,
  }).isRequired,
  errorProps: PropTypes.shape({
    onRender: PropTypes.func,
  }),
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
}

export default InputField
